import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "_bgc--light _rounded--common _pa-1 _flex _gap-2 _jc-st _pos-r",
  "data-qa": "cart-table:product-order-subitem"
}
const _hoisted_2 = { class: "grow-1 _toe" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h4",
  "data-qa": "order-subitem-name"
}
const _hoisted_4 = { class: "gfu-bt gfu-bt--caption _tc--light" }
const _hoisted_5 = {
  class: "gfu-bt gfu-bt--caption _tc--light _toe",
  "data-qa": "order-subitem-options"
}
const _hoisted_6 = {
  key: 1,
  class: "_flex _ai-c _ml-a _px-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.hasFullDescription)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: $options.to,
          title: $props.name
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_image, {
              src: $props.imageUrl,
              alt: $props.name,
              class: "_rounded--input",
              loading: "lazy",
              width: "72",
              height: "72"
            }, null, 8 /* PROPS */, ["src", "alt"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to", "title"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        ($options.hasFullDescription)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: $options.to,
              title: $props.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "title"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Resources.YourPledge.CartTableQuantityHeader) + ": " + _toDisplayString($props.quantity), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString($options.optionsFormatted), 1 /* TEXT */)
    ]),
    ($options.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_tooltip, {
            text: $options.errorMessage,
            "data-qa": "quantity-error-warning-icon-tooltip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "triangle-exclamation",
                class: "_tc--error",
                "data-qa": "cart-table-item-row-quantity-error:WarningIcon"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}